module.exports = __webpack_public_path__ + "img/testimonial_4.dcee7f33.png";